<script setup lang="ts">
import { inject, computed } from 'vue'

defineProps<{
  /** i18n key for the support lead sentence. */
  leadKey: string
}>()

const rootSiteDomain = inject<string>(
  'rootSiteDomain',
  'https://www.swiftaid.co.uk'
)

const links = computed(() => [
  {
    id: 'help',
    href: `${rootSiteDomain}/guide/donor/`,
    labelKey: 'AuthSupport.HelpCentre',
    external: true,
  },
  {
    id: 'message',
    href: `${rootSiteDomain}/donors/manage-account/something-else/`,
    labelKey: 'AuthSupport.Contact',
    external: true,
  },
])
</script>

<template>
  <div class="sa-auth-support">
    <p class="sa-auth-support__lead">{{ $t(leadKey) }}</p>
    <nav class="sa-auth-support__nav" :aria-label="$t('AuthSupport.NavLabel')">
      <template v-for="(link, index) in links" :key="link.id">
        <span v-if="index > 0" class="sa-auth-support__sep" aria-hidden="true">
          ·
        </span>
        <a
          class="sa-link sa-auth-support__link"
          :href="link.href"
          :target="link.external ? '_blank' : undefined"
          :rel="link.external ? 'noopener noreferrer' : undefined"
        >
          {{ $t(link.labelKey) }}
        </a>
      </template>
    </nav>
  </div>
</template>
